// import React, { useState } from 'react';
// import ReactECharts from 'echarts-for-react';
// import { Dropdown } from 'react-bootstrap';

// // Example options for dropdowns
// const companyOptions = [
//     { value: 'company-a', label: 'Company A' },
//     { value: 'company-b', label: 'Company B' },
//     { value: 'company-c', label: 'Company C' },
// ];

// const yearOptions = [
//     { value: '2022', label: '2022' },
//     { value: '2023', label: '2023' },
//     { value: '2024', label: '2024' },
// ];

// const FunnelChart = () => {
//     const [selectedCompany, setSelectedCompany] = useState(companyOptions[0]);
//     const [selectedYear, setSelectedYear] = useState(yearOptions[0]);

//     const handleCompanySelect = (company) => {
//         setSelectedCompany(company);
//     };

//     const handleYearSelect = (year) => {
//         setSelectedYear(year);
//     };

//     const option = {
//         // title: {
//         //     text: 'No of Licence',
//         //     left: 'center',
//         //     textStyle: {
//         //         fontSize: 16,
//         //     },
//         // },
//         tooltip: {
//             trigger: 'item',
//             formatter: '{b}: {c}',
//         },
//         legend: {
//             data: ['LC Provider', 'LC Used', 'LC Available'],
//             top: 0,
//         },
//         series: [
//             {
//                 name: 'Licences',
//                 type: 'funnel',
//                 left: 'center',
//                 top: 50,
//                 bottom: 20,
//                 width: '80%',
//                 minSize: '20%',
//                 maxSize: '100%',
//                 sort: 'descending',
//                 gap: 0,
//                 label: {
//                     show: true,
//                     position: 'inside',
//                     formatter: '{b}',
//                     color: '#fff',
//                 },
//                 labelLine: {
//                     length: 10,
//                     lineStyle: {
//                         width: 1,
//                         type: 'solid',
//                     },
//                 },
//                 itemStyle: {
//                     borderColor: '#fff',
//                     borderWidth: 1,
//                 },
//                 data: [
//                     { value: 200, name: 'LC Provider', itemStyle: { color: '#004AAD' } },
//                     { value: 150, name: 'LC Used', itemStyle: { color: '#0F6657' } },
//                     { value: 100, name: 'LC Available', itemStyle: { color: '#91B2FF' } },
//                 ],
//             },
//         ],
//     };

//     return (
//         <div className='barchart-container'>
//             <div className='funnel-chart-header-div'>
//                 <h6 style={{ margin: 0 }}>No of Licence</h6>

//                 <div className='funnel-chart-btns'>
//                     <Dropdown>
//                         <Dropdown.Toggle id="dropdown-company">
//                             {selectedCompany.label}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             {companyOptions.map(option => (
//                                 <Dropdown.Item
//                                     key={option.value}
//                                     onClick={() => handleCompanySelect(option)}
//                                     active={selectedCompany.value === option.value}
//                                 >
//                                     {option.label}
//                                 </Dropdown.Item>
//                             ))}
//                         </Dropdown.Menu>
//                     </Dropdown>
//                     <Dropdown>
//                         <Dropdown.Toggle id="dropdown-year">
//                             {selectedYear.label}
//                         </Dropdown.Toggle>
//                         <Dropdown.Menu>
//                             {yearOptions.map(option => (
//                                 <Dropdown.Item
//                                     key={option.value}
//                                     onClick={() => handleYearSelect(option)}
//                                     active={selectedYear.value === option.value}
//                                 >
//                                     {option.label}
//                                 </Dropdown.Item>
//                             ))}
//                         </Dropdown.Menu>
//                     </Dropdown>
//                 </div>
//             </div>
//             <div className='funnel-chart'>
//                 <ReactECharts option={option} style={{ height: '100%' }} />
//             </div>
//         </div>
//     );
// };

// export default FunnelChart;



import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
    loadCompanyDropdownData,
    loadComplaintEscalationIssueTypeData,
    loadCustomerDashboardNoofLicencesChartData,
    loadSLADashboardTotalSlaChartData,
} from '../../redux/action';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import * as ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';

// const FunnelChart = ({ moduleName, colors }) => {
const FunnelChart = React.forwardRef(({ moduleName, colors }, ref) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const chartInstance = useRef(null);

    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { complaintEscalationIssueTypeData } = useSelector((state) => state.data);
    const { getCustomerDashboardNoofLicenceChartData } = useSelector((state) => state.data);
    const { getSlaDashboardTotalSlaChartData } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null;
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null;
    const currentYear = new Date().getFullYear();

    const [selectedCompany, setSelectedCompany] = useState({
        value: storedCompanyId,
        label: storedCompanyName,
    });
    const [selectedYear, setSelectedYear] = useState({
        value: currentYear,
        label: currentYear,
    });

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
    }, [dispatch]);

    useEffect(() => {
        if (location.pathname === '/dashboard' || location.pathname === '/') {
            if (selectedCompany && selectedYear) {
                dispatch(loadCustomerDashboardNoofLicencesChartData(selectedCompany.value, selectedYear.value));
            }
        } else if (location.pathname === '/complaintDashboard') {
            if (selectedCompany && selectedYear) {
                dispatch(loadComplaintEscalationIssueTypeData(selectedCompany.value, selectedYear.value));
            }
        } else if (location.pathname === '/slaDashboard') {
            if (selectedCompany && selectedYear) {
                dispatch(loadSLADashboardTotalSlaChartData(selectedCompany.value, selectedYear.value));
            }
        }
    }, [selectedCompany, selectedYear, dispatch, location.pathname]);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
    };

    const handleYearSelect = (year) => {
        setSelectedYear(year);
    };

    const generateYearRange = (startYear) => {
        const years = [];
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }
        return years;
    };

    const formattedComplaintData =
        complaintEscalationIssueTypeData?.map((complaint, index) => ({
            value: complaint.ComplaintsCount || 0,
            name: complaint.IssueTypeName || 'Unknown',
            itemStyle: { color: colors ? colors[index] : '#000' },
        })) || [];

    const formattedLicenseData = [
        {
            value: getCustomerDashboardNoofLicenceChartData?.CompanyTotalLicenses || 0,
            name: 'Total Licenses',
            itemStyle: { color: '#004AAD' },
        },
        {
            value: getCustomerDashboardNoofLicenceChartData?.CompanyUsedLicenses || 0,
            name: 'Used Licenses',
            itemStyle: { color: '#0F6657' },
        },
        {
            value: getCustomerDashboardNoofLicenceChartData?.CompanyAvailableLicenses || 0,
            name: 'Available Licenses',
            itemStyle: { color: '#91B2FF' },
        },
    ];

    const formattedSlaDataForChart = getSlaDashboardTotalSlaChartData.map((sla) => {
        let color = '';
        switch (sla.SLAStatus) {
            case 'Hold':
                color = 'rgba(240, 207, 43, 1)'; // Hold color
                break;
            case 'In-Progress':
                color = 'rgba(255, 94, 0, 1)'; // In-Progress color
                break;
            case 'Completed':
                color = 'rgba(58, 201, 119, 1)'; // Completed color
                break;
            default:
                color = '#000'; // Default color
        }

        return {
            value: sla.SLACount || 0,
            name: sla.SLAStatus || 'Unknown',
            itemStyle: { color: color },
        };
    });

    const isNoData =
        (location.pathname === '/complaintDashboard' && formattedComplaintData.every((item) => item.value === 0)) ||
        (location.pathname === '/dashboar' || location.pathname === '/' && formattedLicenseData.every((item) => item.value === 0)) ||
        (location.pathname === '/slaDashboard' && formattedSlaDataForChart.every((item) => item.value === 0));

    const option = {
        tooltip: {
            trigger: 'item',
            formatter: (params) =>
                params.data.value === 0 ? 'No data available' : `${params.name}: ${params.value}`,
        },
        legend: {
            data:
                location.pathname === '/complaintDashboard'
                    ? formattedComplaintData.map((item) => item.name)
                    : ['Total Licenses', 'Used Licenses', 'Available Licenses'],
            top: 0,
            selectedMode: false,
        },
        grid: {
            top: 80,
            left: '17%',
            right: '10%',
            bottom: 20,
        },
        xAxis: {
            type: 'category',
            data:
                location.pathname === '/complaintDashboard'
                    ? formattedComplaintData.map((item) => item.name)
                    : ['Total Licenses', 'Used Licenses', 'Available Licenses'],
            axisLine: { lineStyle: { color: 'rgba(246, 246, 246, 1)' } },
            axisLabel: { show: false },
            splitLine: { show: false },
        },
        yAxis: {
            type: 'value',
            min: 0,
            max: (() => {
                // Calculate max value based on data
                const data = location.pathname === '/complaintDashboard'
                    ? formattedComplaintData
                    : location.pathname === '/dashboard' || location.pathname === '/'
                        ? formattedLicenseData
                        : location.pathname === '/slaDashboard'
                            ? formattedSlaDataForChart
                            : [];

                const maxValue = Math.max(...data.map((item) => item.value));
                // If there's no data or all values are 0, set max to 1 (so the chart doesn't break)
                return maxValue === 0 ? 1 : maxValue;
            })(),
            interval: (() => {
                // Calculate interval dynamically, but guard against too small or too large numbers
                const data = location.pathname === '/complaintDashboard'
                    ? formattedComplaintData
                    : location.pathname === '/dashboard' || location.pathname === '/'
                        ? formattedLicenseData
                        : location.pathname === '/slaDashboard'
                            ? formattedSlaDataForChart
                            : [];

                const maxValue = Math.max(...data.map((item) => item.value));
                const interval = Math.ceil(maxValue / 4);
                // If there's no data or all values are 0, set interval to a default of 1
                return maxValue === 0 ? 1 : interval;
            })(),
            axisLine: { lineStyle: { color: 'rgba(246, 246, 246, 1)' } },
            axisLabel: { color: 'rgba(143, 145, 143, 1)' },
            splitLine: {
                show: true,
                lineStyle: { color: 'rgba(246, 246, 246, 1)', type: 'line' },
            },
        },
        series: [
            {
                type: 'funnel',
                left: 'right',
                top: 80,
                bottom: 20,
                width: '80%',
                minSize: '20%',
                maxSize: '100%',
                sort: 'descending',
                gap: 0,
                label: { show: false, position: 'inside', formatter: '{b}', color: '#fff' },
                labelLine: { length: 10, lineStyle: { width: 1, type: 'solid' } },
                itemStyle: { borderColor: '#fff', borderWidth: 1 },
                // data:
                //     location.pathname === '/complaintDashboard'
                //         ? formattedComplaintData
                //         : formattedLicenseData,
                data: (() => {
                    if (location.pathname === '/complaintDashboard') {
                        return formattedComplaintData;
                    } else if (location.pathname === '/dashboard' || location.pathname === '/') {
                        return formattedLicenseData;
                    } else if (location.pathname === '/slaDashboard') {
                        return formattedSlaDataForChart; // Assuming this is defined
                    } else {
                        // Default case when no condition is met
                        return [];
                    }
                })(),

            },
        ],
    };

    useImperativeHandle(ref, () => ({
        handleDownloadImage: async () => {
            if (!chartInstance.current) {
                console.error("Chart instance is not available.");
                return;
            }

            const echartsInstance = chartInstance.current.getEchartsInstance();
            if (!echartsInstance) {
                console.error("ECharts instance is not initialized.");
                return;
            }

            // Get chart as an image
            const chartImage = new Image();
            chartImage.src = echartsInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
            });

            // Wait for the image to load before proceeding
            await new Promise((resolve) => {
                chartImage.onload = resolve;
            });

            // Create a container to hold the chart and table
            const container = document.createElement('div');
            container.style.display = 'flex';
            container.style.flexDirection = 'column';
            container.style.alignItems = 'center';
            container.style.padding = '20px';
            container.style.background = 'white';

            // Add the chart image to the container
            const chartCanvas = document.createElement('canvas');
            chartCanvas.width = 600;
            chartCanvas.height = 400;
            const ctx = chartCanvas.getContext('2d');
            ctx.drawImage(chartImage, 0, 0, 600, 400);
            container.appendChild(chartCanvas);

            // Create a table
            const table = document.createElement('table');
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.marginTop = '20px';

            // Table Header
            const headerRow = document.createElement('tr');
            headerRow.innerHTML = `
                <th style="border: 1px solid #ccc; padding: 8px;">Name</th>
                <th style="border: 1px solid #ccc; padding: 8px;">Value</th>
            `;
            table.appendChild(headerRow);

            // Table Data
            const chartData =
                location.pathname === '/complaintDashboard' ? formattedComplaintData :
                    location.pathname === '/dashboard' || location.pathname === '/' ? formattedLicenseData :
                        location.pathname === '/slaDashboard' ? formattedSlaDataForChart : [];

            chartData.forEach((data) => {
                const row = document.createElement('tr');
                row.innerHTML = `
                    <td style="border: 1px solid #ccc; padding: 8px;">${data.name}</td>
                    <td style="border: 1px solid #ccc; padding: 8px;">${data.value}</td>
                `;
                table.appendChild(row);
            });

            // Append table to container
            container.appendChild(table);

            // Append container to body temporarily
            document.body.appendChild(container);

            // Capture everything with html2canvas
            html2canvas(container, { useCORS: true }).then((canvas) => {
                const imageData = canvas.toDataURL('image/png');

                // Download the final image
                const link = document.createElement('a');
                link.href = imageData;
                link.download = 'Funnel_Chart_with_Data.png';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Remove temporary container
                document.body.removeChild(container);
            }).catch((error) => {
                console.error("Error generating image with html2canvas:", error);
            });
        },
        handleDownloadExcel: async () => {
            if (!chartInstance.current) {
                console.error("Chart instance is not available.");
                return;
            }

            // Get chart instance
            const echartsInstance = chartInstance.current.getEchartsInstance();
            if (!echartsInstance) {
                console.error("ECharts instance is not initialized.");
                return;
            }

            // Get chart as a Base64 image
            const chartImage = echartsInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
            });

            // Determine data based on the pathname
            const chartData =
                location.pathname === '/complaintDashboard' ? formattedComplaintData :
                    location.pathname === '/dashboard' || location.pathname === '/' ? formattedLicenseData :
                        location.pathname === '/slaDashboard' ? formattedSlaDataForChart : [];

            // Import ExcelJS dynamically
            import('exceljs').then(async (ExcelJS) => {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Chart Data');

                // Define column headers
                worksheet.columns = [
                    { header: 'Name', key: 'name', width: 25 },
                    { header: 'Value', key: 'value', width: 15 },
                ];

                // Add table data
                chartData.forEach((data) => {
                    worksheet.addRow(data);
                });

                try {
                    // Add chart image to Excel
                    const imageId = workbook.addImage({
                        base64: chartImage,
                        extension: 'png',
                    });

                    // Insert image at a specific range
                    worksheet.addImage(imageId, 'D5:E20');
                } catch (error) {
                    console.error('Error adding chart image:', error);
                }

                // Generate and download Excel file
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                saveAs(blob, 'Funnel_Chart_with_Data.xlsx');
            }).catch((error) => {
                console.error('Error generating Excel file:', error);
            });
        },
        handleDownloadPDF: async () => {
            if (!chartInstance.current) {
                console.error("Chart instance is not available.");
                return;
            }

            // Get chart instance
            const echartsInstance = chartInstance.current.getEchartsInstance();
            if (!echartsInstance) {
                console.error("ECharts instance is not initialized.");
                return;
            }

            // Get chart as an image
            const chartImage = echartsInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
            });

            // Determine data based on the pathname
            const chartData =
                location.pathname === '/complaintDashboard' ? formattedComplaintData :
                    location.pathname === '/dashboard' || location.pathname === '/' ? formattedLicenseData :
                        location.pathname === '/slaDashboard' ? formattedSlaDataForChart : [];

            // Import jsPDF dynamically
            import('jspdf').then(({ default: jsPDF }) => {
                import('jspdf-autotable').then(() => {
                    const pdf = new jsPDF();
                    pdf.setFontSize(18);
                    pdf.text('Funnel Chart Data', 20, 20);

                    // Define table columns
                    const columns = [
                        { header: 'Name', dataKey: 'name' },
                        { header: 'Value', dataKey: 'value' },
                    ];

                    // Add table
                    pdf.autoTable({
                        columns,
                        body: chartData,
                        startY: 30,
                        headStyles: { fillColor: [22, 160, 133] },
                        theme: 'grid',
                    });

                    // Add chart image
                    const finalY = pdf.autoTable.previous.finalY || 30;
                    pdf.addImage(chartImage, 'PNG', 20, finalY + 10, 170, 80);

                    // Save PDF
                    pdf.save('Funnel_Chart_with_Data.pdf');
                });
            }).catch(error => {
                console.error("Error generating PDF:", error);
            });
        },

        handleDownloadWord: async () => {
            if (!chartInstance.current) {
                console.error("Chart instance is not available.");
                return;
            }

            // Get chart instance
            const echartsInstance = chartInstance.current.getEchartsInstance();
            if (!echartsInstance) {
                console.error("ECharts instance is not initialized.");
                return;
            }

            // Get chart as Base64 image
            const chartImage = echartsInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
            });

            // Decode Base64 image
            const base64Data = chartImage.split(",")[1];
            const byteArray = new Uint8Array(
                atob(base64Data).split("").map((char) => char.charCodeAt(0))
            );

            // Determine data based on the pathname
            const chartData =
                location.pathname === '/complaintDashboard' ? formattedComplaintData :
                    location.pathname === '/dashboard' || location.pathname === '/' ? formattedLicenseData :
                        location.pathname === '/slaDashboard' ? formattedSlaDataForChart : [];

            // Import docx dynamically
            import('docx').then(({ Document, Packer, Paragraph, Table, TableRow, TableCell, HeadingLevel, ImageRun }) => {
                const tableRows = chartData.map((data) => {
                    return new TableRow({
                        children: [
                            new TableCell({ children: [new Paragraph(data.name)] }),
                            new TableCell({ children: [new Paragraph(data.value.toString())] }),
                        ],
                    });
                });

                const doc = new Document({
                    sections: [{
                        children: [
                            new Paragraph({ text: "Funnel Chart Data", heading: HeadingLevel.TITLE }),
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({ children: [new Paragraph("Name")], shading: { fill: "CCCCCC" } }),
                                            new TableCell({ children: [new Paragraph("Value")], shading: { fill: "CCCCCC" } }),
                                        ],
                                    }),
                                    ...tableRows,
                                ],
                            }),
                            new Paragraph({ text: "Chart:", spacing: { before: 400, after: 200 } }),
                            new Paragraph({
                                children: [
                                    new ImageRun({
                                        data: byteArray,
                                        transformation: { width: 500, height: 300 },
                                    }),
                                ],
                            }),
                        ],
                    }],
                });

                Packer.toBlob(doc).then((blob) => {
                    saveAs(blob, "Funnel_Chart_with_Data.docx");
                }).catch(error => {
                    console.error("Error generating Word document:", error);
                });
            });
        },

        handlePrint: () => {
            if (!chartInstance.current) {
                console.error("Chart instance is not available.");
                return;
            }

            // Get chart instance
            const echartsInstance = chartInstance.current.getEchartsInstance();
            if (!echartsInstance) {
                console.error("ECharts instance is not initialized.");
                return;
            }

            // Get chart as an image
            const chartImage = echartsInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
            });

            // Determine data based on the pathname
            const chartData =
                location.pathname === '/complaintDashboard' ? formattedComplaintData :
                    location.pathname === '/dashboard' || location.pathname === '/' ? formattedLicenseData :
                        location.pathname === '/slaDashboard' ? formattedSlaDataForChart : [];

            // Generate printable HTML structure
            const printableContent = `
                <html>
                    <head>
                        <title>Print Chart</title>
                        <style>
                            body {
                                font-family: Arial, sans-serif;
                                margin: 20px;
                            }
                            h1 {
                                text-align: center;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 20px;
                            }
                            th, td {
                                border: 1px solid #ccc;
                                padding: 8px;
                                text-align: center;
                            }
                            th {
                                background-color: #f4f4f4;
                            }
                            img {
                                display: block;
                                margin: 20px auto;
                                max-width: 100%;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>Funnel Chart Data</h1>
                        <img src="${chartImage}" alt="Chart Image" />
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${chartData.map((data) =>
                `<tr>
                                        <td>${data.name}</td>
                                        <td>${data.value}</td>
                                    </tr>`).join("")}
                            </tbody>
                        </table>
                        <script>
                            window.onload = function() {
                                window.print();
                            }
                        </script>
                    </body>
                </html>
            `;

            // Open printable content in a new window
            const printWindow = window.open("", "_blank");
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(printableContent);
                printWindow.document.close();
            } else {
                console.error("Failed to open print window.");
            }
        }
    }));

    return (
        <div className='barchart-container'>
            <div className='funnel-chart-header-div'>
                <h6 style={{ margin: 0 }}>{moduleName}</h6>
                <div className='funnel-chart-btns'>
                    <Dropdown>
                        <Dropdown.Toggle id='dropdown-company'>
                            {selectedCompany?.label || 'Select Company'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {getCompanyDropdown.map((option) => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleCompanySelect(option)}
                                    active={selectedCompany.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown>
                        <Dropdown.Toggle id='dropdown-year'>
                            {selectedYear.label}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {generateYearRange(2022).map((option) => (
                                <Dropdown.Item
                                    key={option.value}
                                    onClick={() => handleYearSelect(option)}
                                    active={selectedYear.value === option.value}
                                >
                                    {option.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className='funnel-chart'>
                {isNoData ? (
                    <div style={{ textAlign: 'center', color: '#888' }}>No data available</div>
                ) : (
                    <ReactECharts ref={chartInstance} option={option} style={{ height: '100%' }} />
                )}
            </div>
        </div>
    );
});
export default FunnelChart;


